<a
	(click)="onReviewButton()"
	class="font-normal blue-link-underline"
	[ngClass]="customStyles"
	routerLink="/submit-review"
	[queryParams]="{ uni: universityUrl }"
>
	{{ buttonText }}
</a>
